import React from 'react';
import { concatStyles } from 'utils';
import { HeadingSmall } from './HeadingSmall';
var HEADING_STYLES = 'text-2xl';
export var Heading = function (_a) {
    var _b = _a.bold, bold = _b === void 0 ? false : _b, textTransform = _a.textTransform, margin = _a.margin, className = _a.className, children = _a.children;
    return (React.createElement(HeadingSmall, { bold: bold, textTransform: textTransform, margin: margin, className: concatStyles([HEADING_STYLES, className]) }, children));
};
Heading.displayName = 'Content.Heading';
